export default "__VITE_ASSET__B8Jqt16a__"